<template>
    <div>
        <y-panel-grid :service="$services.Cart.invoicesGrid" />
    </div>
</template>

<script>

    // Mixins
    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'CartInvoiceGrid',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('cart.invoice.title'),
            };
        },
    };
</script>
